/* eslint-disable */
import React, { Component } from "react";
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";
import { t } from './i18n';

/**
 * deposit2.js — Dynamic Deposit Page
 * Route: /deposit2  →  tabselect: 28
 *
 * Calls /api/v1/getdepositconfig to determine which methods are enabled,
 * then shows/hides tabs accordingly. Does NOT modify the existing deposit
 * UI in main.js.
 *
 * Methods:
 *   1. ธนาคารธรรมดา    (hasBank = true)
 *   2. อัพโหลด Slip   (hasBankAutoslip = true, autoslip=1)
 *   3. ทรูมันนี่        (hasTruewallet = true)
 *   4. ของขวัญทรูมันนี่ (hasTruegift = true — same wallet, different method)
 *   5. Payment Gateway (hasPaymentGateway = true)
 */
class Deposit2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            config: null,
            mainacc: null,
            mainaccAutoslip: null,
            truewallet: null,
            paymentgateway: null,
            cryptowallets: [],
            activeTab: null,        // set after config loads
            activeCryptoIdx: 0,     // selected wallet index in crypto tab
            copySuccess: false,
            cryptoCopied: null,     // "address" | "usdt" | null
            cryptoThbAmount: "",    // THB input for converter
            slipFile: null,
            slipUploading: false,
            slipSuccess: false,
            truemoneyAmount: "",
            truemoneyPhone: "",
            truemoneySubmitting: false,
            giftUrl: "",
            giftSubmitting: false,
            depositAmount: "",
        };
    }

    get lang() {
        return localStorage.getItem('lang') || 'th';
    }

    async componentDidMount() {
        await this.loadConfig();
    }

    loadConfig = async () => {
        const token = localStorage.getItem("auth_token");
        if (!token) {
            this.setState({ loading: false });
            return;
        }
        try {
            const res = await instance.post(
                "/api/v1/getdepositconfig",
                { System: Systems },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (res.data.status === 200) {
                const { config, mainacc, mainaccAutoslip, truewallet, paymentgateway, cryptowallets } = res.data;

                let activeTab = null;
                if (config.hasBank)              activeTab = "bank";
                else if (config.hasBankAutoslip) activeTab = "autoslip";
                else if (config.hasTruewallet)   activeTab = "true";
                else if (config.hasPaymentGateway) activeTab = "payment";
                else if (config.hasCrypto)       activeTab = "crypto";

                this.setState({
                    loading: false,
                    config,
                    mainacc,
                    mainaccAutoslip,
                    truewallet,
                    paymentgateway,
                    cryptowallets: cryptowallets || [],
                    activeTab,
                });
            } else {
                this.setState({ loading: false });
            }
        } catch (e) {
            console.error("[deposit2] loadConfig error:", e);
            this.setState({ loading: false });
        }
    };

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copySuccess: true });
            setTimeout(() => this.setState({ copySuccess: false }), 2000);
        });
    };

    handleSlipChange = (e) => {
        this.setState({ slipFile: e.target.files[0] });
    };

    handleSlipUpload = async () => {
        const { slipFile } = this.state;
        if (!slipFile) return;
        const token = localStorage.getItem("auth_token");
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;

        this.setState({ slipUploading: true });
        try {
            const ext = (slipFile.name.match(/\.([a-z0-9]+)$/i)?.[1] || "jpg").toLowerCase();
            const filename = `slip_${Username}_${Date.now()}.${ext}`;
            const formData = new FormData();
            formData.append("file", slipFile, filename);
            formData.append("filename", filename);
            const headers = { "Content-Type": "multipart/form-data" };
            const resUpload = await instance.post(
                "https://r2-public.wordbalance931.workers.dev/upload/slip",
                formData,
                { headers }
            );
            const slip = resUpload?.data?.link || null;
            if (slip) {
                await instance.post("/api/v1/confirmdeposit", {
                    username: Username,
                    System: Systems,
                    slip,
                    type: 7,
                    autoslip: 1,
                }, { headers: { Authorization: `Bearer ${token}` } });
                this.setState({ slipSuccess: true, slipFile: null });
                setTimeout(() => this.setState({ slipSuccess: false }), 3000);
            }
        } catch (e) {
            console.error("[deposit2] slipUpload error:", e);
        }
        this.setState({ slipUploading: false });
    };

    handleTrueSubmit = async () => {
        const { truemoneyAmount, truemoneyPhone } = this.state;
        if (!truemoneyAmount || !truemoneyPhone) return;
        const token = localStorage.getItem("auth_token");
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        this.setState({ truemoneySubmitting: true });
        try {
            await instance.post("/api/v1/deposittruewallet", {
                username: Username,
                System: Systems,
                amount: truemoneyAmount,
                phone: truemoneyPhone,
            }, { headers: { Authorization: `Bearer ${token}` } });
            alert(t(this.lang, 'truemoney_submit_success'));
            this.setState({ truemoneyAmount: "", truemoneyPhone: "" });
        } catch (e) {
            console.error("[deposit2] trueSubmit error:", e);
        }
        this.setState({ truemoneySubmitting: false });
    };

    handleGiftSubmit = async () => {
        const { giftUrl } = this.state;
        if (!giftUrl || !giftUrl.includes("gift.truemoney.com")) return;
        const token = localStorage.getItem("auth_token");
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        this.setState({ giftSubmitting: true });
        try {
            await instance.post("/api/v1/depositgifttrue", {
                username: Username,
                System: Systems,
                linkurl: giftUrl,
            }, { headers: { Authorization: `Bearer ${token}` } });
            alert(t(this.lang, 'gift_submit_success'));
            this.setState({ giftUrl: "" });
        } catch (e) {
            console.error("[deposit2] giftSubmit error:", e);
        }
        this.setState({ giftSubmitting: false });
    };

    renderTabBar() {
        const { config, activeTab } = this.state;
        if (!config) return null;
        const lang = this.lang;

        const tabs = [];
        if (config.hasBank)
            tabs.push({ key: "bank",    label: t(lang, 'bank_tab'),        icon: "🏦" });
        if (config.hasBankAutoslip)
            tabs.push({ key: "autoslip", label: t(lang, 'upload_slip_tab'), icon: "📤" });
        if (config.hasTruewallet)
            tabs.push({ key: "true",    label: t(lang, 'truemoney_tab'),    icon: "📱" });
        if (config.hasTruegift)
            tabs.push({ key: "gift",    label: t(lang, 'truegift_tab'),     icon: "🎁" });
        if (config.hasPaymentGateway)
            tabs.push({ key: "payment", label: "Payment",                   icon: "💳" });
        if (config.hasCrypto)
            tabs.push({ key: "crypto",  label: t(lang, 'crypto_tab'),       icon: "₿" });

        return (
            <ul className="nav nav-tabs d-flex justify-content-center flex-wrap" style={{ gap: "4px", borderBottom: "none" }}>
                {tabs.map((tab) => (
                    <li key={tab.key} className="nav-item text-center" style={{ minWidth: "80px" }}>
                        <a
                            className={`nav-link${activeTab === tab.key ? " active" : ""}`}
                            href="#"
                            onClick={(e) => { e.preventDefault(); this.setState({ activeTab: tab.key }); }}
                            style={{ fontSize: "0.78rem", padding: "6px 10px" }}
                        >
                            <div style={{ fontSize: "1.3rem" }}>{tab.icon}</div>
                            {tab.label}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }

    renderBankTab() {
        const { mainacc, copySuccess, depositAmount } = this.state;
        const lang = this.lang;
        if (!mainacc) return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_bank_account')}</p>;

        const accFmt = `${mainacc.accnumber.substring(0,3)}-${mainacc.accnumber.substring(3,9)}-${mainacc.accnumber.substring(9,12)}`;
        const quickAmounts = [100, 300, 500, 1000, 2000, 5000];

        const bName = (mainacc.fullname_th || "").toLowerCase();
        let cardGrad = "linear-gradient(135deg,#1a237e 0%,#283593 60%,#3949ab 100%)";
        if (bName.includes("กสิกร") || bName.includes("kbank"))   cardGrad = "linear-gradient(135deg,#1b5e20 0%,#2e7d32 60%,#43a047 100%)";
        else if (bName.includes("ไทยพาณิชย์") || bName.includes("scb")) cardGrad = "linear-gradient(135deg,#4a148c 0%,#6a1b9a 60%,#8e24aa 100%)";
        else if (bName.includes("กรุงเทพ") || bName.includes("bbl"))    cardGrad = "linear-gradient(135deg,#0d1b5e 0%,#1a237e 60%,#1565c0 100%)";
        else if (bName.includes("กรุงไทย") || bName.includes("ktb"))    cardGrad = "linear-gradient(135deg,#00695c 0%,#00796b 60%,#00acc1 100%)";
        else if (bName.includes("ทหารไทย") || bName.includes("ttb"))    cardGrad = "linear-gradient(135deg,#0d47a1 0%,#1565c0 60%,#1e88e5 100%)";
        else if (bName.includes("กรุงศรี") || bName.includes("bay"))    cardGrad = "linear-gradient(135deg,#bf360c 0%,#d84315 60%,#f4511e 100%)";

        return (
            <div className="p-3">
                {/* ── Bank Card ── */}
                <div style={{
                    background: cardGrad,
                    borderRadius: "20px",
                    padding: "22px 20px",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 10px 36px rgba(0,0,0,0.45)",
                    marginBottom: "16px",
                }}>
                    {/* Decorative blobs */}
                    <div style={{ position:"absolute", top:-40, right:-40, width:130, height:130, borderRadius:"50%", background:"rgba(255,255,255,0.06)", pointerEvents:"none" }} />
                    <div style={{ position:"absolute", bottom:-30, left:-25, width:100, height:100, borderRadius:"50%", background:"rgba(255,255,255,0.05)", pointerEvents:"none" }} />

                    {/* Row 1: logo + bank name + badge */}
                    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"18px" }}>
                        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                            <div style={{ width:46, height:46, borderRadius:"12px", background:"rgba(255,255,255,0.92)", display:"flex", alignItems:"center", justifyContent:"center", padding:"4px", flexShrink:0 }}>
                                <img src={mainacc.img_path} alt="bank" style={{ width:"100%", height:"100%", objectFit:"contain" }} />
                            </div>
                            <div>
                                <div style={{ color:"rgba(255,255,255,0.6)", fontSize:"0.65rem", letterSpacing:"0.06em", textTransform:"uppercase" }}>{t(lang, 'bank_dest')}</div>
                                <div style={{ color:"#fff", fontWeight:"bold", fontSize:"0.95rem", lineHeight:1.3 }}>{mainacc.fullname_th}</div>
                            </div>
                        </div>
                        <div style={{ background:"rgba(255,255,255,0.15)", backdropFilter:"blur(4px)", borderRadius:"20px", padding:"4px 12px", fontSize:"0.68rem", color:"rgba(255,255,255,0.85)", border:"1px solid rgba(255,255,255,0.2)", whiteSpace:"nowrap" }}>
                            {t(lang, 'savings_type')}
                        </div>
                    </div>

                    {/* Row 2: account number */}
                    <div style={{ marginBottom:"14px" }}>
                        <div style={{ color:"rgba(255,255,255,0.5)", fontSize:"0.66rem", marginBottom:"4px", letterSpacing:"0.08em" }}>{t(lang, 'acc_no_label')}</div>
                        <div style={{ color:"#fff", fontSize:"1.35rem", fontWeight:"bold", letterSpacing:"0.16em", fontFamily:"'Courier New',monospace" }}>
                            {accFmt}
                        </div>
                    </div>

                    {/* Row 3: account holder */}
                    <div>
                        <div style={{ color:"rgba(255,255,255,0.5)", fontSize:"0.66rem", marginBottom:"2px", letterSpacing:"0.06em" }}>{t(lang, 'account_name')}</div>
                        <div style={{ color:"rgba(255,255,255,0.9)", fontSize:"0.88rem", fontWeight:"600", letterSpacing:"0.04em" }}>
                            {mainacc.first_name_en} {mainacc.last_name_en}
                        </div>
                    </div>
                </div>

                {/* ── Copy button ── */}
                <button
                    onClick={() => this.copyToClipboard(mainacc.accnumber)}
                    style={{
                        width:"100%",
                        background: copySuccess
                            ? "linear-gradient(135deg,#00c853,#009624)"
                            : "linear-gradient(135deg,rgba(255,255,255,0.1),rgba(255,255,255,0.05))",
                        border: copySuccess ? "1px solid #00c853" : "1px solid rgba(255,255,255,0.18)",
                        borderRadius:"12px",
                        color: copySuccess ? "#00e676" : "#fff",
                        padding:"13px",
                        fontSize:"0.9rem",
                        fontWeight:"bold",
                        cursor:"pointer",
                        transition:"all 0.3s ease",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center",
                        gap:"8px",
                        marginBottom:"14px",
                        letterSpacing:"0.03em",
                    }}
                >
                    <span style={{ fontSize:"1.1rem" }}>{copySuccess ? "✓" : "📋"}</span>
                    {copySuccess ? t(lang, 'copy_acc_done') : `${t(lang, 'copy_acc_prefix')}  ${accFmt}`}
                </button>

                {/* ── Quick amount ── */}
                <div style={{ marginBottom:"12px" }}>
                    <div style={{ color:"rgba(255,255,255,0.55)", fontSize:"0.72rem", marginBottom:"8px", textAlign:"center" }}>
                        {t(lang, 'select_deposit_amount')}
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"6px" }}>
                        {quickAmounts.map((amt) => (
                            <button
                                key={amt}
                                onClick={() => this.setState({ depositAmount: String(amt) })}
                                style={{
                                    background: depositAmount === String(amt)
                                        ? "linear-gradient(135deg,#f9a825,#e65100)"
                                        : "rgba(255,255,255,0.07)",
                                    border: depositAmount === String(amt) ? "none" : "1px solid rgba(255,255,255,0.13)",
                                    borderRadius:"9px",
                                    color: depositAmount === String(amt) ? "#fff" : "rgba(255,255,255,0.65)",
                                    padding:"9px 4px",
                                    fontSize:"0.83rem",
                                    fontWeight: depositAmount === String(amt) ? "bold" : "normal",
                                    cursor:"pointer",
                                    transition:"all 0.2s",
                                }}
                            >
                                ฿{amt.toLocaleString()}
                            </button>
                        ))}
                    </div>
                </div>

                {/* ── Amount input ── */}
                <div style={{
                    display:"flex", alignItems:"center",
                    background:"rgba(0,0,0,0.28)",
                    borderRadius:"11px",
                    border:"1px solid rgba(255,255,255,0.15)",
                    overflow:"hidden",
                    marginBottom:"14px",
                }}>
                    <span style={{ padding:"0 14px", fontSize:15, color:"#f9a825", fontWeight:"bold", borderRight:"1px solid rgba(255,255,255,0.1)", flexShrink:0 }}>฿</span>
                    <input
                        type="number"
                        min="0"
                        placeholder={t(lang, 'enter_amount')}
                        value={depositAmount || ""}
                        onChange={(e) => this.setState({ depositAmount: e.target.value })}
                        style={{ flex:1, background:"transparent", border:"none", outline:"none", color:"#fff", fontSize:15, fontWeight:"bold", padding:"12px 10px" }}
                    />
                    <span style={{ padding:"0 12px", fontSize:"0.72rem", color:"rgba(255,255,255,0.38)", flexShrink:0 }}>THB</span>
                </div>

                {/* ── Warning ── */}
                <div style={{
                    background:"rgba(255,152,0,0.1)",
                    border:"1px solid rgba(255,152,0,0.28)",
                    borderRadius:"11px",
                    padding:"10px 14px",
                    display:"flex", gap:"8px", alignItems:"flex-start",
                }}>
                    <span style={{ fontSize:"1rem", flexShrink:0, marginTop:"1px" }}>⚠️</span>
                    <div style={{ fontSize:"0.72rem", color:"rgba(255,255,255,0.65)", lineHeight:"1.55" }}>
                        {t(lang, 'bank_transfer_warning')}
                    </div>
                </div>
            </div>
        );
    }

    renderAutoslipTab() {
        const { mainaccAutoslip, slipFile, slipUploading, slipSuccess, copySuccess } = this.state;
        const lang = this.lang;
        if (!mainaccAutoslip) return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_autoslip')}</p>;
        const accFmt = `${mainaccAutoslip.accnumber.substring(0,3)}-${mainaccAutoslip.accnumber.substring(3,9)}-${mainaccAutoslip.accnumber.substring(9,12)}`;
        return (
            <div className="p-3">
                <div className="deposit-card">
                    <div className="deposit-bankline">
                        <img className="deposit-banklogo" src={mainaccAutoslip.img_path} alt="bank" />
                        <div className="deposit-bankname">{mainaccAutoslip.fullname_th}</div>
                    </div>
                    <div className="deposit-accline">
                        {mainaccAutoslip.first_name_en} {mainaccAutoslip.last_name_en} : {accFmt}
                    </div>
                    <div className="deposit-actions mt-2">
                        <button
                            className="deposit-btn deposit-btn--ghost w-100"
                            onClick={() => this.copyToClipboard(mainaccAutoslip.accnumber)}
                        >
                            {t(lang, 'acc_no_label')} : <b>{accFmt}</b>
                            &nbsp;<span className="deposit-chip">{copySuccess ? "✓ " + t(lang, 'copied') : t(lang, 'copy')}</span>
                        </button>
                    </div>
                </div>
                <div className="mt-3">
                    <label className="text-white-v1 d-block mb-1" style={{ fontSize: "0.85rem" }}>📎 {t(lang, 'upload_slip_auto_label')}</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={this.handleSlipChange}
                        disabled={slipUploading}
                        className="form-control mb-2"
                        style={{ background: "rgba(255,255,255,0.1)", color: "#fff" }}
                    />
                    {slipFile && (
                        <button
                            className="btn w-100 p-2"
                            style={{ background: "linear-gradient(135deg,#00c853,#009624)", color: "#fff", fontWeight: "bold", borderRadius: "8px" }}
                            onClick={this.handleSlipUpload}
                            disabled={slipUploading}
                        >
                            {slipUploading ? "⏳ " + t(lang, 'uploading') : "✅ " + t(lang, 'confirm_upload_slip')}
                        </button>
                    )}
                    {slipSuccess && (
                        <div className="alert mt-2 text-center" style={{ background: "rgba(0,200,83,0.2)", color: "#00c853", border: "1px solid #00c853", borderRadius: "8px" }}>
                            ✅ {t(lang, 'upload_success_checking')}
                        </div>
                    )}
                </div>
                <small className="text-center d-block mt-2" style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.78rem" }}>
                    ⚠️ {t(lang, 'transfer_warning_short')}
                </small>
            </div>
        );
    }

    renderTrueTab() {
        const { truewallet, truemoneyAmount, truemoneyPhone, truemoneySubmitting } = this.state;
        const lang = this.lang;
        if (!truewallet) return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_truewallet')}</p>;
        return (
            <div className="p-3">
                <div className="deposit-card text-center">
                    <img
                        src="/images/local/ic-truemoney.png"
                        alt="TrueMoney"
                        style={{ width: 56, height: 56, borderRadius: 12, marginBottom: 8 }}
                    />
                    <div className="deposit-bankname">TrueMoney Wallet</div>
                    <div className="deposit-accline">{truewallet.telnumber || truewallet.acctelnumber || ""}</div>
                </div>
                <div className="mt-3">
                    <label className="text-white-v1 d-block mb-1" style={{ fontSize: "0.85rem" }}>{t(lang, 'amount_label')}</label>
                    <input
                        type="number"
                        className="form-control mb-2"
                        placeholder={t(lang, 'enter_amount')}
                        value={truemoneyAmount}
                        onChange={(e) => this.setState({ truemoneyAmount: e.target.value })}
                        style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)" }}
                    />
                    <label className="text-white-v1 d-block mb-1" style={{ fontSize: "0.85rem" }}>{t(lang, 'truemoney_phone_label')}</label>
                    <input
                        type="tel"
                        className="form-control mb-3"
                        placeholder="0XX-XXX-XXXX"
                        value={truemoneyPhone}
                        onChange={(e) => this.setState({ truemoneyPhone: e.target.value })}
                        style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)" }}
                    />
                    <button
                        className="btn w-100 p-3"
                        style={{ background: "linear-gradient(135deg,#f6a200,#e67e00)", color: "#fff", fontWeight: "bold", borderRadius: "8px" }}
                        onClick={this.handleTrueSubmit}
                        disabled={truemoneySubmitting || !truemoneyAmount || !truemoneyPhone}
                    >
                        {truemoneySubmitting ? "⏳ " + t(lang, 'submitting') : "📱 " + t(lang, 'notify_truemoney_deposit')}
                    </button>
                </div>
            </div>
        );
    }

    renderGiftTab() {
        const { giftUrl, giftSubmitting } = this.state;
        const lang = this.lang;
        return (
            <div className="p-3">
                <div className="text-center mb-3">
                    <div style={{ fontSize: "2.5rem" }}>🎁</div>
                    <div className="text-white-v1" style={{ fontWeight: 700 }}>{t(lang, 'deposit_gift_truemoney')}</div>
                    <small style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.78rem" }}>
                        {t(lang, 'gift_paste_hint')}
                    </small>
                </div>
                <label className="text-white-v1 d-block mb-1" style={{ fontSize: "0.85rem" }}>{t(lang, 'gift_link_label')}</label>
                <input
                    type="url"
                    className="form-control mb-3"
                    placeholder="https://gift.truemoney.com/campaign/?v=..."
                    value={giftUrl}
                    onChange={(e) => this.setState({ giftUrl: e.target.value })}
                    style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)" }}
                />
                <button
                    className="btn w-100 p-3"
                    style={{ background: "linear-gradient(135deg,#e91e63,#c2185b)", color: "#fff", fontWeight: "bold", borderRadius: "8px" }}
                    onClick={this.handleGiftSubmit}
                    disabled={giftSubmitting || !giftUrl.includes("gift.truemoney.com")}
                >
                    {giftSubmitting ? "⏳ " + t(lang, 'checking') : "🎁 " + t(lang, 'send_gift_link')}
                </button>
            </div>
        );
    }

    renderPaymentTab() {
        const { paymentgateway } = this.state;
        const lang = this.lang;
        if (!paymentgateway) return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_payment_gateway')}</p>;
        return (
            <div className="p-3 text-center">
                <div style={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.8)" }} className="mb-3">
                    💳 Payment Gateway
                </div>
                {paymentgateway.QRcode ? (
                    <img
                        src={paymentgateway.QRcode}
                        alt="QR Code"
                        style={{ maxWidth: 220, borderRadius: 12, background: "#fff", padding: 8 }}
                    />
                ) : paymentgateway.link ? (
                    <a
                        href={paymentgateway.link}
                        className="btn w-100 p-3"
                        style={{ background: "linear-gradient(135deg,#1976d2,#0d47a1)", color: "#fff", fontWeight: "bold", borderRadius: "8px" }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        💳 {t(lang, 'pay_via_gateway')}
                    </a>
                ) : (
                    <p style={{ color: "rgba(255,255,255,0.6)" }}>{t(lang, 'contact_admin')}</p>
                )}
            </div>
        );
    }

    renderCryptoTab() {
        const { cryptowallets, activeCryptoIdx, cryptoCopied, cryptoThbAmount } = this.state;
        const lang = this.lang;
        if (!cryptowallets || cryptowallets.length === 0)
            return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_crypto')}</p>;

        const wallet = cryptowallets[activeCryptoIdx] || cryptowallets[0];

        const netColor = { TRC20: "#c62828", ERC20: "#1565c0", BEP20: "#e65100", BTC: "#f9a825" };
        const tagColor = netColor[wallet.network] || "#37474f";

        return (
            <div className="p-3">
                {/* Wallet selector pills */}
                {cryptowallets.length > 1 && (
                    <div className="d-flex flex-wrap justify-content-center mb-3" style={{ gap: "6px" }}>
                        {cryptowallets.map((w, i) => (
                            <button
                                key={w.no}
                                onClick={() => this.setState({ activeCryptoIdx: i, cryptoCopied: null })}
                                style={{
                                    background: i === activeCryptoIdx ? "linear-gradient(135deg,#f9a825,#e65100)" : "rgba(255,255,255,0.1)",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "5px 14px",
                                    fontSize: "0.8rem",
                                    cursor: "pointer",
                                    fontWeight: i === activeCryptoIdx ? "bold" : "normal",
                                }}
                            >
                                {w.currency} <span style={{ opacity: 0.8, fontSize: "0.72rem" }}>({w.network})</span>
                            </button>
                        ))}
                    </div>
                )}

                {/* Exchange rate converter */}
                {(() => {
                    const rate = parseFloat(wallet.rate) || 36;
                    const thb  = parseFloat(cryptoThbAmount) || 0;
                    const usdt = thb > 0 ? (Math.ceil((thb / rate) * 1000) / 1000).toFixed(3) : null;
                    return (
                        <div style={{ marginBottom: 14 }}>
                            {/* Rate badge */}
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, background: "rgba(249,168,37,0.12)", border: "1px solid rgba(249,168,37,0.35)", borderRadius: 8, padding: "7px 14px", marginBottom: 10 }}>
                                <span style={{ fontSize: 16, color: "#f9a825" }}>₿</span>
                                <span style={{ fontSize: 13, color: "#f9a825", fontWeight: "bold" }}>1 {wallet.currency || "USDT"}</span>
                                <span style={{ fontSize: 12, color: "rgba(255,255,255,0.55)" }}>=</span>
                                <span style={{ fontSize: 13, color: "#fde68a", fontWeight: "bold" }}>
                                    {rate.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {t(lang, 'baht')}
                                </span>
                            </div>

                            {/* THB input */}
                            <div style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.65)", marginBottom: 6 }}>{t(lang, 'crypto_thb_label')}</div>
                            <div style={{ display: "flex", alignItems: "center", background: "rgba(0,0,0,0.25)", borderRadius: 8, border: "1px solid rgba(249,168,37,0.4)", overflow: "hidden", marginBottom: usdt ? 8 : 0 }}>
                                <span style={{ padding: "0 12px", fontSize: 14, color: "#fde68a", fontWeight: "bold", borderRight: "1px solid rgba(249,168,37,0.3)" }}>฿</span>
                                <input
                                    type="number"
                                    min="0"
                                    placeholder="0.00"
                                    value={cryptoThbAmount || ""}
                                    onChange={(e) => this.setState({ cryptoThbAmount: e.target.value })}
                                    style={{ flex: 1, background: "transparent", border: "none", outline: "none", color: "#fff", fontSize: 15, fontWeight: "bold", padding: "10px 12px" }}
                                />
                                <span style={{ padding: "0 10px", fontSize: 12, color: "rgba(255,255,255,0.45)" }}>THB</span>
                            </div>

                            {/* Converted result */}
                            {usdt && (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "rgba(0,0,0,0.25)", border: "1px solid rgba(74,222,128,0.35)", borderRadius: 8, padding: "10px 14px" }}>
                                    <div>
                                        <div style={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.5)", marginBottom: 2 }}>{t(lang, 'crypto_amount_prefix')} {wallet.currency || "USDT"} {t(lang, 'crypto_amount_suffix')}</div>
                                        <div style={{ fontSize: 20, fontWeight: "bold", color: "#4ade80" }}>{usdt}</div>
                                        <div style={{ fontSize: "0.68rem", color: "rgba(255,255,255,0.4)" }}>{wallet.currency} · {wallet.network}</div>
                                    </div>
                                    <button
                                        onClick={() => { navigator.clipboard.writeText(usdt); this.setState({ cryptoCopied: "usdt" }); setTimeout(() => this.setState({ cryptoCopied: null }), 2000); }}
                                        style={{ background: "rgba(74,222,128,0.15)", border: "1px solid rgba(74,222,128,0.4)", borderRadius: 7, padding: "6px 12px", color: "#4ade80", fontSize: "0.75rem", cursor: "pointer", flexShrink: 0 }}
                                    >
                                        {cryptoCopied === "usdt" ? "✓ " + t(lang, 'copied') : "📋 " + t(lang, 'copy')}
                                    </button>
                                </div>
                            )}
                        </div>
                    );
                })()}

                {/* Wallet card */}
                <div style={{
                    background: "linear-gradient(135deg,rgba(249,168,37,0.15),rgba(230,81,0,0.15))",
                    border: "1px solid rgba(249,168,37,0.4)",
                    borderRadius: "12px",
                    padding: "16px",
                }}>
                    {/* Currency + Network */}
                    <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                        <span style={{ fontSize: "1.6rem" }}>₿</span>
                        <div>
                            <div style={{ color: "#f9a825", fontWeight: "bold", fontSize: "1rem" }}>{wallet.currency}</div>
                            <span style={{
                                background: tagColor,
                                color: "#fff",
                                borderRadius: "10px",
                                padding: "1px 8px",
                                fontSize: "0.7rem",
                                fontWeight: "bold",
                            }}>{wallet.network}</span>
                        </div>
                        <div className="ms-auto text-end" style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.55)" }}>
                            {t(lang, 'min_label_short')} {parseFloat(wallet.min_amount).toFixed(2)} {wallet.currency}
                        </div>
                    </div>

                    {/* QR Code */}
                    {wallet.qrcode_img && (
                        <div className="text-center mb-3">
                            <img
                                src={wallet.qrcode_img}
                                alt="QR"
                                style={{ width: "150px", height: "150px", borderRadius: "8px", background: "#fff", padding: "4px" }}
                            />
                        </div>
                    )}

                    {/* Wallet address */}
                    <div style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.6)", marginBottom: "6px" }}>{t(lang, 'wallet_address_label')}</div>
                    <button
                        className="w-100"
                        onClick={() => {
                            navigator.clipboard.writeText(wallet.wallet_address);
                            this.setState({ cryptoCopied: "address" });
                            setTimeout(() => this.setState({ cryptoCopied: null }), 2500);
                        }}
                        style={{
                            background: "rgba(255,255,255,0.08)",
                            border: "1px solid rgba(249,168,37,0.35)",
                            borderRadius: "8px",
                            color: "#fff",
                            padding: "10px 12px",
                            fontSize: "0.78rem",
                            wordBreak: "break-all",
                            textAlign: "left",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                        }}
                    >
                        <span style={{ flex: 1 }}>{wallet.wallet_address}</span>
                        <span style={{
                            background: cryptoCopied === "address" ? "rgba(0,200,83,0.3)" : "rgba(249,168,37,0.25)",
                            color: cryptoCopied === "address" ? "#00c853" : "#f9a825",
                            borderRadius: "6px",
                            padding: "3px 8px",
                            fontSize: "0.7rem",
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                        }}>
                            {cryptoCopied === "address" ? "✓ " + t(lang, 'copied') : "📋 " + t(lang, 'copy')}
                        </span>
                    </button>
                </div>

                <small className="d-block text-center mt-3" style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.73rem" }}>
                    ⚠️ {t(lang, 'crypto_send_only')} {wallet.currency} {t(lang, 'crypto_network')} {wallet.network} {t(lang, 'crypto_send_only_suffix')}<br />
                    {t(lang, 'crypto_wrong_type_warning')}
                </small>
            </div>
        );
    }

    renderActiveTab() {
        const { activeTab } = this.state;
        switch (activeTab) {
            case "bank":     return this.renderBankTab();
            case "autoslip": return this.renderAutoslipTab();
            case "true":     return this.renderTrueTab();
            case "gift":     return this.renderGiftTab();
            case "payment":  return this.renderPaymentTab();
            case "crypto":   return this.renderCryptoTab();
            default:         return null;
        }
    }

    render() {
        const { loading, config } = this.state;
        const lang = this.lang;

        return (
            <div className="padding-router-view">
                <div className="container p-0 x-margin-top-v3">
                    <div className="row m-0 border-shadow-title">
                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            {/* Header */}
                            <div className="text-center bg-title-web">
                                <div className="text-title text-white-v1 text-center">
                                    <div className="d-flex justify-content-between p-2">
                                        <div className="text-white-v1-deposit">
                                            <a role="button" onClick={() => this.props.onBack && this.props.onBack()}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="currentColor" className="bi bi-arrow-left-circle text-white" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 1 1 1 .708.708L5.707 7.5z" />
                                                </svg>
                                            </a>
                                        </div>
                                        <div className="text-white-v1-deposit"><h5>{t(lang, 'deposit_title')}</h5></div>
                                        <div>{/**/}</div>
                                    </div>
                                    <hr className="mt-0" />
                                </div>
                            </div>

                            <div className="p-1 bg-deposit-button example animated animatedFadeInUp fadeInUp">
                                {loading ? (
                                    <div className="text-center text-white-v1 py-5">
                                        <div className="spinner-border text-light" role="status" />
                                        <div className="mt-2">{t(lang, 'loading')}</div>
                                    </div>
                                ) : !config ? (
                                    <div className="text-center text-white-v1 py-5">
                                        {t(lang, 'load_failed_retry')}
                                    </div>
                                ) : (
                                    <>
                                        {/* Tab Bar */}
                                        <div className="pt-2 px-2">
                                            {this.renderTabBar()}
                                        </div>
                                        {/* Active Tab Content */}
                                        <div className="mt-1">
                                            {this.renderActiveTab()}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Deposit2;
